import { Input, type InputProps } from '../ui';

// Mirror of the server-side regex in pkg/ukpostcode — keep in sync.
const UK_POSTCODE_RE = /^[A-Z]{1,2}[0-9][A-Z0-9]? ?[0-9][A-Z]{2}$/i;

export function looksLikeUKPostcode(raw: string): boolean {
  return UK_POSTCODE_RE.test(raw.trim());
}

export type PostcodeInputProps = InputProps;

export function PostcodeInput({
  placeholder = 'SW1A 1AA',
  autoComplete = 'postal-code',
  ...rest
}: PostcodeInputProps): JSX.Element {
  return (
    <Input
      placeholder={placeholder}
      autoComplete={autoComplete}
      inputMode="text"
      spellCheck={false}
      {...rest}
    />
  );
}
